<template>
  <el-option disabled value="-1" class="disable">
    <div class="select-handle">
      <a @click="selectHandler('select')">
        <i class="el-icon-check"></i>
        {{ $locale("global.selectAll") }}
      </a>
      <a @click="selectHandler('empty')">
        <i class="el-icon-close"></i>
        {{ $locale("global.deselectAll") }}
      </a>
    </div>
  </el-option>
</template>
<script>
export default {
  name: "multi-select",
  props: {
    list: {
      type: Array,
      required: true,
    },
    dataList: {
      type: Array,
      required: true,
    },
    useType: {
      type: String,
      default: "",
    }
  },
  methods: {
    selectHandler(type) {
      this.$emit("update:list", []);
      if (this.useType === "all" && type === "select") {
        let _arr = [];
        _arr.push("all");
        this.$emit("update:list", _arr);
        return;
      } else if (type === "select") {
        let _arr = [];
        this.dataList.map(item => {
          _arr.push(item.id);
        });
        this.$emit("update:list", _arr);
      }
    }
  }
};
</script>
<style lang="less" scoped>
  .disable {
    cursor: pointer !important;
    .select-handle {
      color: @other-grey;
      font-size: 16px;
      a {
        display: inline-block;

        &:first-child {
          margin-right: 30px;
        }

        &:hover {
          font-weight: 600;
          color: @primary-orange;

          > i {
            color: @primary-orange;
          }
        }
      }
    }
  }
</style>